<template>
  <div class="bd-callout mt-0 mb-0 bd-callout-info">
        <h4>You have successfully submitted an application for this opportunity. </h4>
        <div class="pt-4">
            <div class="row">
                <div class="col-6">
                    <label class="small text-muted">Status</label>
                    <p class="mb-0"><span
                            v-html="statusBadge(item.status)"></span></p>
                </div>
                <div class="col-6">
                    <div v-if="item.status == 'applied'">
                        <label class="small text-muted">Applied on</label>
                        <p class="mb-0">{{ $filters.date(item.applied_at) }}
                        </p>
                    </div>
                    <div v-if="item.status == 'shortlisted'">
                        <label class="small text-muted">Shortlisted on</label>
                        <p class="mb-0">{{ $filters.date(item.shortlisted_at)
                        }}</p>
                    </div>
                    <div v-if="item.status == 'accepted_shortlisting'">
                        <label class="small text-muted">Accepted Shortlisting on</label>
                        <p class="mb-0">{{
                            $filters.date(item.accepted_shortlisting_at) }}
                        </p>
                    </div>
                    <div v-if="item.status == 'rejected_shortlisting'">
                        <label class="small text-muted">Rejected Shortlisting on</label>
                        <p class="mb-0">{{
                            $filters.date(item.rejected_shortlisting_at) }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-grid pt-4">
                <router-link class="btn btn-primary"
                    :to="`/matched-opportunities/${item.id}`">Read
                    more</router-link>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props:{
        item:{
            type:Object,
            required: true
        }
    }, 
}
</script>

<style>

</style>